module.exports = __webpack_public_path__ + "static/anxious-mobile-7104a05addb045a6075eab463bc99df5.webp";